import React from "react";

const CloseIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14.047"
      height="14.05"
      viewBox="0 0 14.047 14.05"
    >
      <g id="cls_ic" transform="translate(-4.963 -4.953)">
        <path
          id="Path_338"
          data-name="Path 338"
          d="M5.459,18.963a.5.5,0,0,1-.349-.848L18.155,5.11a.5.5,0,0,1,.708.708L5.808,18.853A.5.5,0,0,1,5.459,18.963Z"
          transform="translate(0 0)"
          fill={fill && fill}
        />
        <path
          id="Path_339"
          data-name="Path 339"
          d="M18.5,18.963a.5.5,0,0,1-.349-.15L5.11,5.808A.5.5,0,0,1,5.818,5.1L18.853,18.155A.5.5,0,0,1,18.5,19Z"
          transform="translate(0 0)"
          fill={fill && fill}
        />
      </g>
    </svg>
  );
};

export default CloseIcon;
